import api from "../config/api";
import type { ApiResponse, Booking, PaginatedResponse } from "../types";

export interface CreateBookingRequest {
  customer: string;
  course: string;
  scheduledDate: string;
  scheduledTime: string;
  assignedTherapists?: string[];
  assignedRoom?: string;
  notes?: string;
}

export interface GetBookingsParams {
  page?: number;
  limit?: number;
  date?: string;
  status?: string;
  therapist?: string;
  room?: string;
}

export const bookingService = {
  getBookings: async (params: GetBookingsParams = {}): Promise<PaginatedResponse<Booking>> => {
    const response = await api.get('/bookings', { params });
    return response.data;
  },

  getBooking: async (id: string): Promise<ApiResponse<Booking>> => {
    const response = await api.get(`/bookings/${id}`);
    return response.data;
  },

  createBooking: async (data: CreateBookingRequest): Promise<ApiResponse<Booking>> => {
    const response = await api.post('/bookings', data);
    return response.data;
  },

  updateBooking: async (id: string, data: Partial<CreateBookingRequest>): Promise<ApiResponse<Booking>> => {
    const response = await api.put(`/bookings/${id}`, data);
    return response.data;
  },

  cancelBooking: async (id: string, reason: string): Promise<ApiResponse<Booking>> => {
    const response = await api.delete(`/bookings/${id}`, { data: { cancellationReason: reason } });
    return response.data;
  },

  confirmBooking: async (id: string): Promise<ApiResponse<Booking>> => {
    const response = await api.put(`/bookings/${id}/confirm`);
    return response.data;
  },

  getTodayBookings: async (): Promise<ApiResponse<Booking[]>> => {
    const response = await api.get('/bookings/today/list');
    return response.data;
  },

  getBookingsByDate: async (date: string): Promise<ApiResponse<Booking[]>> => {
    const response = await api.get(`/bookings/date/${date}`);
    return response.data;
  },
};